import { render, staticRenderFns } from "./TodoItem.vue?vue&type=template&id=1e0fb87f&"
import script from "./TodoItem.vue?vue&type=script&lang=js&"
export * from "./TodoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0fb87f')) {
      api.createRecord('1e0fb87f', component.options)
    } else {
      api.reload('1e0fb87f', component.options)
    }
    module.hot.accept("./TodoItem.vue?vue&type=template&id=1e0fb87f&", function () {
      api.rerender('1e0fb87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/todo/TodoItem.vue"
export default component.exports